import * as React from "react";

import { FileWatchTriggerConfig } from "../../model/ITriggerData";
import { InputMode } from "./TriggerInput";
import { TypedTriggerInput } from "./TypedTriggerInput";

export const TriggerInput = TypedTriggerInput as new () => TypedTriggerInput<FileWatchTriggerConfig>;

export const FileWatchTrigger: React.FunctionComponent<FileWatchTriggerProps> = (props) => {
    return <div>
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="dirToWatch"
            label={FRENDS.Localizations.Directory}
            inputMode={InputMode.text}
            elementId={props.id}
        />
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="fileMask"
            label={FRENDS.Localizations.FileMask}
            inputMode={InputMode.text}
            elementId={props.id}
        />
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="includeSubDirectories"
            label={FRENDS.Localizations.IncludeSubDirectories}
            inputMode={InputMode.boolean}
            elementId={props.id}
        />
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="maxFilesPerBatch"
            label={FRENDS.Localizations.MaxNumberOfFilesInBatch}
            inputMode={InputMode.number}
            elementId={props.id}
        />
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="pollIntervalSeconds"
            label={FRENDS.Localizations.PollIntervalSeconds}
            inputMode={InputMode.number}
            elementId={props.id}
        />
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="quietPeriodSeconds"
            label={FRENDS.Localizations.QuietPeriodSeconds}
            description={FRENDS.Localizations.QuietPeriodSecondsDescription}
            inputMode={InputMode.number}
            elementId={props.id}
        />
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="username"
            label={FRENDS.Localizations.Username}
            inputMode={InputMode.text}
            elementId={props.id}
        />
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="password"
            label={FRENDS.Localizations.Password}
            inputMode={InputMode.password}
            elementId={props.id}
            isSecret={true}
        />
    </div>;
};

interface FileWatchTriggerProps {
    id: string;
    existingParameters: FileWatchTriggerConfig;
}
